import React, { useEffect } from 'react';

import { useRef, useState } from 'react'

import * as THREE from 'three'
import { Canvas, RootState, useFrame, useThree } from '@react-three/fiber'


import * as oct from '../knotfree-ts-lib/3d/Dns8Tree';
import { OriginAxisDisplay } from './OriginAxisDisplay';

import * as bvts from '../knotfree-ts-lib/3d/BuildVisibleTreeStatus';
// import { WorldDisplayState } from './WorldDisplayState';
// import * as pubsub from '../knotfree-ts-lib/avatars/PubSubTopicAndSubscribers'
import * as sub from '../knotfree-ts-lib/avatars/PubSubSimple'
import { LeafRenderingComponent } from './MiscCubeRenderElements';

import { RetreiveTheDemoCubes, MakeBoxesForDemoSpaces, MakeBoxesForDemoSpacesLines } from './DemoProperties'
import * as utils from '../knotfree-ts-lib/3d/utils';

import { OutlineBoxComponent } from './OutlineBoxComponent'
import { MakeAuxGroupsFromShowingLeaves, MakeBoxesForShowingGroups } from './MakeBoxesForShowingLeaves'
import * as messes from '../knotfree-ts-lib/3d/messageTypes'
import { mainpubsub } from '../App';


// let samples = "meta_group_id.testmain-0n0u0e4p,meta_group_id.testmain-1n0u0e4p,meta_group_id.testmain-2n0u0e4p"
// // save in local storage for later?
// let sampleArray = samples.split(",").map(s => s.trim())
// console.log("sampleArray ", sampleArray)

// I don't think you need half the stuff in the WorldDisplayState. It's just a bunch of stuff that should be in local storage. 
// The only thing you need is the   and the toggleOnlyShowOutlineBoxes function. The rest is just noise.
// add back toggleOnlyShowOutlineBoxes later

export type MainWorldDisplayProps = {

  worldName: string // like a traditional at this point. 
  onlyShowOutlineBoxes: boolean
  showOriginAxis: boolean

  showingLeaves: string[]
}

// MainWorldDisplay the the main component that displays the world. 
// It will also handle the tree traversal and updating the cubes to render based on the camera position. 
// It will also subscribe to changes in the demo spaces and update the cubes to render accordingly.
// There's two of these when the OrbitPropertyDialog is open. So, tree traversal is BROKEN. 

// which one is the only show address one. It needs a key stroke to toggle it. The other one is just a display of the world.
// it's onlyShowOutlineBoxes it comes in with the WorldDisplayState
// 

export function MainWorldDisplay(props: MainWorldDisplayProps) {

  // Show the demo spaces, or prospective properties, as outlines with their addresses.
  // we subscribe to this. The value doesn't matter.
  const [demoSpacesVersion, setDemoSpacesVersion] = React.useState("")

  // Don't show the normal content. Show boxes without outlines instead. comes on on the props. 
  // We're going to have to publish for this one.
  //cconst [onlyShowOutlineBoxes, setOnlyShowOutlineBoxes] = React.useState(props.state.onlyShowOutlineBoxes)

  //props.state.uniqueId, " show demos=", demoSpacesVersion, " onlyShowOutlineBoxes=", props.state.onlyShowOutlineBoxes, " showOriginAxis=", props.state.showOriginAxis)

  React.useEffect(() => {
    mainpubsub.subscribe("DemoPropertiesChanges", "MainWorldDisplay", false,(status: Object, err: Error) => {

      // I don't really care about the value I just want to re-trigger a calc of the property spaces.
      const cubes = RetreiveTheDemoCubes()
      setDemoSpacesVersion("" + status) // force a redraw.
    },"resets demo properties to trigger a redraw")
    return () => {
      mainpubsub.unsubscribe("DemoPropertiesChanges", "MainWorldDisplay" )
    }
  });// just subscribe all the time. 

  // I thought the key listener would be released so I put it here. But it doesn't get released. 
// so I'll put it to sleep.
  // React.useEffect(() => {
  //   const myHandleKeyDown = (e: KeyboardEvent) => {
  //     switch (e.key) {
  //       case '=': {
  //         if (e.ctrlKey && e.shiftKey) {
  //           console.log("ctrl shift equals key pressed");
  //           // but, the state has a toggle for this.
  //           // props.toggleOnlyShowOutlineBoxes()
  //         }
  //       }
  //         break;
  //     }
  //   };
  //   // We STILL need to unhook this addEventListener ?? 
  //   window.addEventListener('keydown', myHandleKeyDown);
  //   // console.log("NavigationCamera installation: added keydown listener");

  //   return () => {
  //     // how do we make THIS happen so that the dialog will work? Just don't make the main canvas!!! 
  //     console.log("NavigationCamera cleanup: removing keydown listener");
  //     window.removeEventListener('keydown', myHandleKeyDown);
  //   }
  // }, []);

  React.useEffect(() => {

    // TODO: move this somewhere else 

    // subscribe for changes to the various GLB's that the iFrames are going to declare.
    // we collect them and make into auxRecords. 

    // no. The iFrames know their name and acan publush directly,
    sub.subscribe("xxxGlbCreatedMessage", (message: messes.GlbMessage, err: Error | null) => {

      const leafName = message.name

      // send it to the leaf. 

      // why are we even here. Why does the leaf drawer not just subscribe directly?

      // TODO: re'write this. What it means is add a GLB to a leaf.
      // It should also be able to delete them and say if it's currently to be drawn.

      // console.log("MainWorldDisplay got GlbMessage", message, err)
      // if (message && message.type === "glb") {// do we need this?
      //   // we need to store this in the auxTreeStatus for the leaf.
      //   const leafName = message.name
      //   let auxTreeStatus = oct.nameToAuxTreeStatus[leafName] // is this right?
      //   if (auxTreeStatus == null) {
      //     auxTreeStatus = { 
      //       names: [leafName], glbBlobs: {}
      //      }
      //   }
      //       auxTreeStatus.glbBlobs[message.key] = message.data
      //       oct.nameToAuxTreeStatus[leafName] = auxTreeStatus

      // now, can we reforce a redraw of the leaf. We know it's name
      // this is really reset drawing info and the redraw is inferred.
      console.log("MainWorldDisplay got GlbMessage, sending to leaf ", leafName)
     //  sub.publish(leafName + "-redraw", message.key)
      //  }
    });
    return () => {
      sub.unsubscribe("xxxGlbCreatedMessage");
    };
  });

  // these would get flushed with every re-render, which would be bad. We need them to persist. So we put them in the state.What state?
  // previousCameraPosition: new THREE.Vector3(1e999, 0, 0),
  // timeSinceLastCameraMovement: 0,

  // what if I put them in a ref?

  // if the showingLeaves changed, and there's demoSpaces, then we need to re-calc the demo spaces.
  // if the demoSpaces changed, then we need to re-calc the demo spaces.
  // but, it doesn't happen often and the demo spaces are not always on. 
  //   toggle: toggleOnlyShowOutlineBoxes
  function ReCalcTheDemoProperties(): oct.Cube[] {

    // console.log("ReCalcTheDemoProperties: TOP")

    // this will get them out of localStorage.getItem("DemoProperties")
    const demoCubes = RetreiveTheDemoCubes()
    if (props.showingLeaves.length === 0) { // no point
      // console.log("ReCalcTheDemoProperties: no showingLeaves, returning all the demoCubes ", demoCubes.length)
      return demoCubes
    }

    // TODO: do this only if demoCubes or showingLeaves changed.

    const demoCubesFiltered = []

    // need to filter these!  
    if (demoCubes.length > 0) {
      const intersector = new oct.OctTreeIntersector(props.worldName)
      for (const leafName of props.showingLeaves) {
        const [cube, err] = oct.StringToCube(leafName)
        if (err) {
          console.error("ReCalcTheDemoProperties: error converting leafName to cube ", leafName, err)
          continue
        }
        intersector.AddKnownCube(cube)
      }

      for (const cube of demoCubes) {
        const [was, err] = intersector.CheckForIntersection(cube)
        if (was) {
          // console.log("ReCalcTheDemoProperties: demo cube ", cube, " intersects with showingLeaves, skipping")
          continue
        }
        demoCubesFiltered.push(cube)
      }
    }
    return demoCubesFiltered
  }

  const demoCubes = ReCalcTheDemoProperties()

  function showAxis() {
    if (props.showOriginAxis) {
      return (<OriginAxisDisplay />)
    }
    return null
  }

  const MakeBoxesForShowingArgs = {
    worldName: props.worldName,
    showingLeaves: props.showingLeaves,
    onlyShowOutlineBoxes: props.onlyShowOutlineBoxes,
    showOriginAxis: props.showOriginAxis
  }
  // This does not return a component. It processes the leaves into the groups.
  // and then publishes the groups. It takes a while but comes right back with nothiing.
  // The things it found up in the pubsub system. 
  // They get picked up the MakeBoxesForShowingGroups component and rendered as iFrames.


  MakeAuxGroupsFromShowingLeaves(MakeBoxesForShowingArgs);

// MakeBoxesForDemoSpacesLines

  return (<>

    {showAxis()}

    {/* You guys are history.
      <DrawDogComponent cube={cube1} /> */}
    {/* <OutlineBoxComponent cube={cube1} errorMsg={undefined}
      propsMessage={"Under construction. Hard hats required."} />

    <OutlineBoxComponent cube={cube2} errorMsg={undefined} propsMessage={"this space 4 sale"} /> */}
    {/* <OutlineBoxComponent cube={cube3} errorMsg={undefined} propsMessage={"Condemned. "} /> */}

    <MakeBoxesForDemoSpacesLines
      worldName={props.worldName}
      demoCubeList={demoCubes}
      color={"green"}
    />

    

    <MakeBoxesForShowingGroups 
      worldName={props.worldName}
      onlyShowOutlineBoxes={props.onlyShowOutlineBoxes}
      showOriginAxis={props.showOriginAxis}
      showingLeaves={props.showingLeaves}
    />

  </>)

}













// can I trash this yet?

// we'll use the names, sorted, so it can tell when it changes.
// no state for this. We pass it in to tigger.
// const [showingLeaves, setShowingLeaves] = React.useState("")

// never call setUniqueId. It's just a unique string to identify this instance of the component for pubsub purposes.
//const [uniqueId, setUniqueId] = React.useState(ourState.current.uniqueId)

// watch for changes in the demo spaces.
// will this trigger a re-render?
// no, pass these as props
// const [demoSpacesVersion, setDemoSpacesVersion] = React.useState("")

// const tmpstr = ReCalcTheDemoProperties(ourState.current) // this will get called on every render, which is not ideal. We could memoize it or something if we wanted to be sure it only gets called when the relevant state changes. For now it's just a console log so it's not a big deal.

// const [demoSpacesString, setDemoSpacesString] = React.useState(tmpstr)

// function setShowingLeavesString(str: string) {
//   setShowingLeaves(str)
// }

// no man, leaves get passed in.
// React.useEffect(() => {
//   // become addicted to showingLeaves state changes as mainWorldShowingLeavesChanges .

//   pubsub.subscribe("ShowingLeavesChanges", "mainWorld"+uniqueId,
//     (status: Object, err: Error) => {

//     console.log(`ShowingLeavesChanges${uniqueId} got pubsub message`, status, err)
//     if (status && typeof status === "string") {
//       setShowingLeavesString(status as string)
//     } else {
//       // got funny object from pubsub. Expected a string.
//       console.log(`ShowingLeavesChanges${uniqueId} got pubsub message but it's not a string`, status)
//       // setShowingLeavesString("") // and now there's none.
//     }
//   })

//   return () => {
//     pubsub.unsubscribe("ShowingLeavesChanges", "mainWorldShowingLeavesChanges")
//     console.log("ShowingLeavesChanges useEffect cleanup")
//   };
// }, []) // like once, ever. showingLeaves

// we should pass these in too.
// React.useEffect(() => {
//   console.log("MainWorldDisplay DemoPropertiesChanges" + uniqueId)
//   pubsub.subscribe("DemoPropertiesChanges", "MainWorldDisplay" + uniqueId, (status: Object, err: Error) => {

//     console.log(`MainWorldDisplay${uniqueId} got pubsub message`, status, err)
//     // I don't really care about the value I just want to re-trigger a calc of the property spaces.

//     const str = ReCalcTheDemoProperties(ourState.current)
//     setDemoSpacesString(str) // force a redraw.

//     if (status && typeof status === "string") {
//       setDemoSpacesVersion(status as string)
//     } else {
//       // got funny object from pubsub. Expected a string.
//       console.log(`MainWorldDisplay${uniqueId} got pubsub message but it's not a string`, status)
//       setDemoSpacesVersion("" + status) // and now it's off.
//     }
//   })
//   return () => {
//     pubsub.unsubscribe("DemoPropertiesChanges", "MainWorldDisplay" + uniqueId)
//     console.log(`MainWorldDisplay${uniqueId} useEffect DemoPropertiesChanges cleanup`)
//   };
// }, [demoSpacesVersion])


// if (ourState.current.uniqueId !== uniqueId) {
//   console.log("MainWorldDisplay uniqueId mismatch ", ourState.current.uniqueId, " to ", uniqueId)
// }



// Copyright 2026 Alan Tracey Wootton
// See LICENSE
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.

// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.

// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <http://www.gnu.org/licenses/>.
